import React, { Component } from 'react';
import classes from './Controls.css';
import arrowBack from '../../img/arrowBack.svg';
import arrowForth from '../../img/arrowForth.svg';
import Wrapper from '../../hoc/Wrapper/Wrapper';

class Controls extends Component {

    render() {
        let controlsClasses = [classes.Controls, classes.Closed];
        if (this.props.open) {
            controlsClasses = [classes.Controls, classes.Open];
        }
        return (
            <Wrapper>
                {window.innerWidth < 769 && this.props.open &&
                <div
                    className={classes.Backdrop}
                    onClick={this.props.toggleControls}
                    >
                </div>}
                <aside className={controlsClasses.join(' ')}>
                  {/*
                    <div className={classes.inputGroup}>
                        <input type="checkbox" id="text1" className={classes.textCheckbox} checked={this.props.checked1} onChange={(e) => this.props.onInputCheck(e, "checked1")}/>
                        <label htmlFor="text1"></label>
                        <input type="text" className={classes.textInput} placeholder="Введите текст" onChange={(e) => this.props.onInputChange(e, "text1")}/>
                    </div>
                    <div className={classes.inputGroup}>
                        <input type="checkbox" id="text2" className={classes.textCheckbox} checked={this.props.checked2} onChange={(e) => this.props.onInputCheck(e, "checked2")}/>
                        <label htmlFor="text2"></label>
                        <input type="text" className={classes.textInput} placeholder="Введите текст" onChange={(e) => this.props.onInputChange(e, "text2")}/>
                    </div>
                    <div className={classes.inputGroup}>
                        <input type="checkbox" id="text3" className={classes.textCheckbox} checked={this.props.checked3} onChange={(e) => this.props.onInputCheck(e, "checked3")}/>
                        <label htmlFor="text3"></label>
                        <input type="text" className={classes.textInput} placeholder="Введите текст" onChange={(e) => this.props.onInputChange(e, "text3")}/>
                    </div>*/}

                    <div className={classes.buttonGroup}>
                        <div className={classes.buttonHeader}>Фон</div>
                        <button
                            className={[classes.button, classes.SwitchBtn].join(' ')}
                            onClick={this.props.choosePrevBackground}
                            style={{backgroundImage: `url(${arrowBack})`}}>
                        </button>
                        <button
                            className={[classes.button, classes.SwitchBtn].join(' ')}
                            onClick={this.props.chooseNextBackground}
                            style={{backgroundImage: `url(${arrowForth})`}}>
                        </button>
                    </div>

                    <div className={classes.buttonGroup}>
                        <div className={classes.buttonHeader}>Верхняя рамка</div>
                        <button
                            className={[classes.button, classes.SwitchBtn].join(' ')}
                            onClick={this.props.choosePrevFrameTop}
                            style={{backgroundImage: `url(${arrowBack})`}}>
                        </button>
                        <button
                            className={[classes.button, classes.SwitchBtn].join(' ')}
                            onClick={this.props.chooseNextFrameTop}
                            style={{backgroundImage: `url(${arrowForth})`}}>
                        </button>
                    </div>

                    <div className={classes.buttonGroup}>
                        <div className={classes.buttonHeader}>Нижняя рамка</div>
                        <button
                            className={[classes.button, classes.SwitchBtn].join(' ')}
                            onClick={this.props.choosePrevFrameBottom}
                            style={{backgroundImage: `url(${arrowBack})`}}>
                        </button>
                        <button
                            className={[classes.button, classes.SwitchBtn].join(' ')}
                            onClick={this.props.chooseNextFrameBottom}
                            style={{backgroundImage: `url(${arrowForth})`}}>
                        </button>
                    </div>
                  {/*
                    <div className={classes.buttonGroup}>
                        <div className={classes.buttonHeader}>Начертание</div>
                        <button
                            className={[classes.button, classes.SwitchBtn].join(' ')}
                            onClick={this.props.choosePrevFont}
                            style={{backgroundImage: `url(${arrowBack})`}}>
                        </button>
                        <button
                            className={[classes.button, classes.SwitchBtn].join(' ')}
                            onClick={this.props.chooseNextFont}
                            style={{backgroundImage: `url(${arrowForth})`}}>
                        </button>
                    </div>

                    <div className={classes.buttonGroup}>
                        <div className={classes.buttonHeader}>Оформление текста</div>
                        <button
                            className={[classes.button, classes.SwitchBtn].join(' ')}
                            onClick={this.props.choosePrevStyle}
                            style={{backgroundImage: `url(${arrowBack})`}}>
                        </button>
                        <button
                            className={[classes.button, classes.SwitchBtn].join(' ')}
                            onClick={this.props.chooseNextStyle}
                            style={{backgroundImage: `url(${arrowForth})`}}>
                        </button>
                    </div>
                    <div className={[classes.buttonGroup, classes.colorButtons].join(' ')}>
                        <div className={classes.buttonHeader}>Цвет текста</div>
                        <div className={[classes.textInput, classes.colorInput].join(' ')} style={{backgroundColor: this.props.textColor}}></div>
                        <button
                            className={[classes.button, classes.SwitchBtn, classes.colorBtn].join(' ')}
                            onClick={this.props.toggleShowPalette}
                            style={{backgroundImage: `url(${arrowForth})`}}>
                        </button>
                        {this.props.showPalette && <div className={classes.paletteBlock}>
                            {this.props.palette.map(color=> {
                                return <span key={color} id={color} style={{backgroundColor: color}} onClick={(e) => this.props.chooseTextColor(e)}></span>
                            })}
                        </div>}

                    </div>

                    <div className={classes.buttonGroup}>
                        <div className={classes.buttonHeader}>Размер шрифта</div>
                        <div className={classes.Switchgroup}>
                            <button
                                className={[classes.button, classes.SwitchBtn].join(' ')}
                                onClick={() => this.props.reduceFont('font1')}
                                style={{backgroundImage: `url(${arrowBack})`}}>
                            </button>
                            <button
                                className={[classes.button, classes.SwitchBtn].join(' ')}
                                onClick={() => this.props.expandFont('font1')}
                                style={{backgroundImage: `url(${arrowForth})`}}>
                            </button>
                        </div>
                        <div className={classes.Switchgroup}>
                            <button
                                className={[classes.button, classes.SwitchBtn].join(' ')}
                                onClick={() => this.props.reduceFont('font2')}
                                style={{backgroundImage: `url(${arrowBack})`}}>
                            </button>
                            <button
                                className={[classes.button, classes.SwitchBtn].join(' ')}
                                onClick={() => this.props.expandFont('font2')}
                                style={{backgroundImage: `url(${arrowForth})`}}>
                            </button>
                        </div>
                        <div className={classes.Switchgroup}>
                            <button
                                className={[classes.button, classes.SwitchBtn].join(' ')}
                                onClick={() => this.props.reduceFont('font3')}
                                style={{backgroundImage: `url(${arrowBack})`}}>
                            </button>
                            <button
                                className={[classes.button, classes.SwitchBtn].join(' ')}
                                onClick={() => this.props.expandFont('font3')}
                                style={{backgroundImage: `url(${arrowForth})`}}>
                            </button>
                        </div>
                    </div>
                   */}

                    {/*<div className={[classes.buttonGroup, classes.colorButtons].join(' ')}>
                        <div className={[classes.buttonHeader, classes.giftButtonHeader].join(' ')} onClick={this.props.toggleShowGiftPalette} style={{cursor: 'pointer'}}>Добавить подарок</div>
                        <button
                          className={[classes.button, classes.SwitchBtn, classes.colorBtn, classes.giftButton].join(' ')}
                          onClick={this.props.toggleShowGiftPalette}
                          style={{backgroundImage: `url(${arrowForth})`}}>
                        </button>
                      {this.props.showGiftPalette && <div className={[classes.paletteBlock, classes.giftsBlock].join(' ')}>
                        {this.props.giftsList.map(gift=> {
                          return <span key={gift.name} id={gift.name} style={{backgroundImage: `url(${gift.url})`, backgroundSize: 'contain'}} onClick={(e) => this.props.addGift(e,gift.name)}>{gift.rusname}</span>
                        })}
                      </div>}
                    </div>*/}

                    <div className={classes.buttonGroup}>
                        <div className={classes.buttonHeader}>Добавить фотографию</div>
                        <input type="file" id="loadAvatar" className={classes.fileInput} onChange={(e) => this.props.onFileInputChange(e)}/>
                        <label htmlFor="loadAvatar" className={classes.button}>Добавить</label>
                    </div>
                    <div className={classes.buttonGroup}>
                        <button className={[classes.button, classes.js_randomize].join(' ')} onClick={this.props.randomize} style={{backgroundColor: '#dc0623', borderColor: '#dc0623'}}>Случайная конфигурация</button>
                    </div>
                    <div className={classes.buttonGroup}>
                        <button className={[classes.button, classes.js_randomize].join(' ')} onClick={this.props.addText}>Добавить текст</button>
                    </div>

                    {/*
                    <div className={classes.buttonGroup}>
                        <button className={[classes.button, classes.js_sendToServer].join(' ')} onClick={this.props.sendToServer}>Отправить на обложку</button>
                    </div>
                     */}

                    {/*
                    <div className={classes.buttonGroup}>
                        <button className={[classes.button, classes.js_saveStage].join(' ')} onClick={(e) => this.props.addShape(e, "circle")}>Добавить круг</button>
                        <button className={[classes.button, classes.js_saveStage].join(' ')} onClick={(e) => this.props.addShape(e, "rect")}>Добавить квадрат</button>
                    </div>

                    <div className={classes.buttonGroup}>
                        <button className={[classes.button, classes.js_sendToServer].join(' ')} onClick={(e) => this.props.addGift(e, "grena")}>Добавить гранату</button>
                        <button className={[classes.button, classes.js_saveStage].join(' ')} onClick={(e) => this.props.addGift(e, "skull")}>Добавить череп орка</button>
                    </div>*/}

                  <div className={[classes.fontDecorationBlock, this.props.currentTextSet.unit !== null && classes.show].join(' ')}>
                        <div className={classes.inputGroup}>
                            <label htmlFor="text"></label>
                            <input type="text" value={this.props.currentTextSet.value} className={classes.textInput} placeholder="Введите текст" onChange={(e) => this.props.findTextAndSetProps(e, "value")}/>
                        </div>
                        <div className={classes.buttonHeader}>Размер шрифта</div>
                        <div className={classes.Switchgroup}>
                            <button
                              className={[classes.button, classes.SwitchBtn].join(' ')}
                              onClick={() => this.props.findTextAndSetProps(false, "size")}
                              style={{backgroundImage: `url(${arrowBack})`}}>
                            </button>
                            <span>{this.props.currentTextSet.size}</span>
                            <button
                              className={[classes.button, classes.SwitchBtn].join(' ')}
                              onClick={() => this.props.findTextAndSetProps(true, "size")}
                              style={{backgroundImage: `url(${arrowForth})`}}>
                            </button>
                        </div>
                        <div className={[classes.buttonGroup, classes.colorButtons].join(' ')}>
                            <div className={classes.buttonHeader}>Цвет текста</div>
                            <div className={[classes.textInput, classes.colorInput].join(' ')} style={{backgroundColor: this.props.currentTextSet.color, cursor: 'pointer'}} onClick={this.props.toggleShowPalette}></div>
                            <button
                              className={[classes.button, classes.SwitchBtn, classes.colorBtn].join(' ')}
                              onClick={this.props.toggleShowPalette}
                              style={{backgroundImage: `url(${arrowForth})`}}>
                            </button>
                          {this.props.showPalette && <div className={classes.paletteBlock}>
                            {this.props.palette.map(color=> {
                              return <span key={color} id={color} style={{backgroundColor: color}} onClick={(e) => this.props.findTextAndSetProps(e, "color")}></span>
                            })}
                          </div>}

                        </div>
                        <div className={classes.Switchgroup}>
                            <div className={classes.buttonHeader}>Начертание</div>
                            <button
                              className={[classes.button, classes.SwitchBtn].join(' ')}
                              onClick={() => this.props.findTextAndSetProps(false, "family")}
                              style={{backgroundImage: `url(${arrowBack})`}}>
                            </button>
                            <span style={{fontFamily: this.props.currentTextSet.family}}>{this.props.currentTextSet.family.slice(0, this.props.currentTextSet.family.indexOf(','))}</span>
                            <button
                              className={[classes.button, classes.SwitchBtn].join(' ')}
                              onClick={() => this.props.findTextAndSetProps(true, "family")}
                              style={{backgroundImage: `url(${arrowForth})`}}>
                            </button>
                        </div>
                        <div className={classes.buttonGroup}>
                            <div className={classes.buttonHeader}>Оформление текста</div>
                            <button
                              className={[classes.button, classes.button_style, !this.props.italic && classes.button_style_unpressed].join(' ')}
                              onClick={() => this.props.findTextAndSetProps(true, "italic")}
                              style={{fontStyle: 'italic'}}
                              >i
                            </button>
                            <button
                              className={[classes.button, classes.button_style, !this.props.bold && classes.button_style_unpressed].join(' ')}
                              onClick={() => this.props.findTextAndSetProps(true, "bold")}
                              style={{fontWeight: 'bold'}}
                            >b
                            </button>
                            <button
                              className={[classes.button, classes.button_style, !this.props.underline && classes.button_style_unpressed].join(' ')}
                              onClick={() => this.props.findTextAndSetProps(true, "underline")}
                              style={{textDecoration: 'underline'}}
                            >u
                            </button>
                        </div>
                    </div>
                    <div className={classes.buttonGroup}>
                        <button  className={[classes.button, classes.js_saveStage].join(' ')} onClick={this.props.onStageSave}>Сохранить открытку</button>
                    </div>
                </aside>
            </Wrapper>
        );
    }
}
export default Controls;



// WEBPACK FOOTER //
// ./src/components/Controls/Controls.js